import { app } from '../../../../env'

export const MIN_AMOUNT = app.ADJUST_AMOUNT_MIN
export const MAX_AMOUNT = app.ADJUST_AMOUNT_MAX
export const MAX_DIGITS = 7
